import { render, staticRenderFns } from "./OtherProblemDiscrepancy.vue?vue&type=template&id=cb8c331c&"
import script from "./OtherProblemDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./OtherProblemDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports